import { render, staticRenderFns } from "./destineAdd.vue?vue&type=template&id=730c6543&scoped=true&"
import script from "./destineAdd.vue?vue&type=script&lang=js&"
export * from "./destineAdd.vue?vue&type=script&lang=js&"
import style0 from "./destineAdd.vue?vue&type=style&index=0&id=730c6543&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730c6543",
  null
  
)

export default component.exports